<mat-sidenav-container class="sidenav-container">
    @if (store.isAuthenticated()) {
        <mat-sidenav mode="side"
                     [opened]="store.isSidenavOpen()"
                     class="sidenav">
            <mat-nav-list class="sidenav-nav">
                @for (item of store.visibleNav(); track item.label) {
                    @if (item.children) {
                        <mat-expansion-panel class="nav-expansion-panel"
                                             [attr.data-test-id]="item.testId ?? null">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="nav-expansion-title">
                                    @if (item.icon) {
                                        <mat-icon>{{ item.icon }}</mat-icon>
                                    }
                                    {{ item.label }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-nav-list class="nav-subitem-list">
                                @for (child of item.children; track child.label) {
                                    <a mat-list-item
                                       class="nav-subitem"
                                       [routerLink]="child.route"
                                       routerLinkActive="nav-active"
                                       [attr.data-test-id]="child.testId ?? null">
                                        <span matListItemTitle>{{ child.label }}</span>
                                    </a>
                                }
                            </mat-nav-list>
                        </mat-expansion-panel>
                    } @else {
                        <a mat-list-item
                           [routerLink]="item.route"
                           routerLinkActive="nav-active"
                           [attr.data-test-id]="item.testId ?? null">
                            @if (item.icon) {
                                <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
                            }
                            <span matListItemTitle>{{ item.label }}</span>
                        </a>
                    }
                }
            </mat-nav-list>
        </mat-sidenav>
    }

    <mat-sidenav-content>
        @if (store.isAuthenticated()) {
            <mat-toolbar class="app-toolbar">
                <button mat-icon-button
                        type="button"
                        (click)="store.toggleSidenav()">
                    <mat-icon>menu</mat-icon>
                </button>
                <span>Nanny Admin</span>
                <span class="toolbar-spacer"></span>
                <mat-select [value]="countryDomainService.activeCountry"
                            (selectionChange)="onCountryChange($event.value)"
                            class="country-select">
                    @for (country of allCountries; track country) {
                        <mat-option [value]="country">{{ countryLabels[country] }}</mat-option>
                    }
                </mat-select>
                <na-status-chip class="env-chip"
                                [label]="store.apiEnvironmentLabel()"
                                [tone]="store.apiEnvironmentTone()"
                                [tooltip]="store.apiBaseUrl()"
                                testId="app-env-chip" />
                <button mat-icon-button
                        type="button"
                        (click)="logout()"
                        title="Exit">
                    <mat-icon>logout</mat-icon>
                </button>
            </mat-toolbar>
        }

        <main class="main-content">
            <router-outlet />
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>

@if (store.isAuthenticated()) {
    <na-ai-agent-chat-panel />
}
